export const SET_MODAL = 'SET_MODAL';

export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';


export const CLEAR_ERRORS = 'CLEAR_ERRORS';
